import { init as initFullStory } from '@fullstory/browser';
import { environment } from '~/constantDefinitions';

export const initializeFullstoryClient = (): void => {
  initFullStory({ orgId: 'tBi', devMode: environment !== 'production' });
};
